import React from "react"

function UploadSuccess({ contentData }) {
  const successHeading =
    contentData &&
    contentData.successHeading &&
    contentData.successHeading.split(".")
  return (
    <div className="upload-success-container">
      <div className="success-image">
        <img
          src={contentData?.emailSuccessIcon?.url}
          alt={contentData?.emailSuccessIcon?.fileName}
          width="136"
          height="140"
        />
      </div>
      <div className="upload-success-heading">
        {successHeading[0]}.
        <br />
        {successHeading[1]}
      </div>
      <p className="upload-success-message">{contentData?.successMessage}</p>
    </div>
  )
}

export default UploadSuccess
